module.exports = __webpack_public_path__ + "img/deepseek_active_icon.eab7c203.svg";